<template>
  <table class="table">
    <thead>
      <tr>
        <th class="qty">QTY:</th>
        <th class="qty">50</th>
        <th class="qty">100</th>
        <th class="qty">250</th>
        <th class="qty">500</th>
        <th class="qty">1000</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="row in rows" :key="row.name">
        <td class="product">{{row.name}}</td>
        <td
          v-for="qty in [50,100,250,500,1000]"
          :class="{price: true, na: !row.prices[qty]}"
          :key="qty"
        >{{price(row, qty)}}</td>
      </tr>
    </tbody>
  </table>
</template>

<style scoped lang="scss">
@import "~scss/colors";
table {
  width: 100%;
  font-size: 15px;
  line-height: 1;
  color: $black-1;
  margin-bottom: 0;
}
.table thead th {
  border-bottom: none;
}

.table {
  width: auto;
  th.qty,
  td.price {
    text-align: right;
    width: 100%; //width of table
  }
  td.na {
    color: $black-1;
  }
  td.product {
    text-align: left;
    color: $black-1;
    min-width: 12em; //width of prod name column
  }
  td,
  th {
    border: none;
    padding: 1rem;
  }
  tbody tr {
    border: $frost-0 1px solid;
    font-size: medium;
  }
  .qty {
    font-weight: bold;
  }
}

tr:nth-child(even) {
  background: $frost-0;
}

th.qty {
  background: $medium-blue;
  color: #fff;
  padding: 1rem;
  &:first-child {
    background: $dark-blue;
    // min-width:365px;
    text-align: left;
  }
}

@media (min-width: 1140px) {
  .table {
    font-size: 22px;
    padding: 1rem 0;
  }
}

@media (max-width: 1140px) {
  .table {
    padding: 0.5rem;
  }
}

// medium devices - shrinks table to fit

@media (max-width: 992px) {
  .pricing-table {
    margin: 1em 0;
  }
  .table {
    max-width: 95%;
    margin: 0 auto;
  }
  .form-row,
  .table-header {
    max-width: 95%;
    margin: 0 auto;
  }
  .form-row span {
    margin-top: 1em;
  }
  .qty,
  .product {
    font-size: 12px;
  }
  .table-header,
  th,
  td,
  .form-row span {
    font-size: 11px;
    letter-spacing: 0;
    padding: 0rem;
  }
  [class*="col"] {
    padding: 0;
    margin: 0;
  }
}

// Extra small devices (portrait phones, less than 576px)
@media (max-width: 576px) {
  .table {
    max-width: 100%;
    td.product {
      min-width: 0;
      max-width: 60px;
      width: 10px !important; //width of prod name column

      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
    td,
    th {
      padding: 0.5rem;
    }
    .qty,
    .product,
    .price {
      font-weight: normal;
      font-size: 11px;
      letter-spacing: 0;
    }
  }
  th.qty:first-child {
    min-width: 0;
    max-width: 60px;

    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
  }
}

/* pricing tables on/off */

.form-row {
  max-height: 37px;
}

.square-prices {
  display: block;
}
.round-prices {
  display: none;
}

.table-header,
th,
.form-row span {
  height: 40px;
  text-transform: uppercase;
  font-weight: normal;
  font-size: 15px;
  letter-spacing: 3px;
  line-height: 1;
  padding: 0.75rem;
}
</style>

<script>
import { prices } from "@/data/prices.json";
import { viewedPricing } from "@/lib/track/events";

export default {
  props: ["category", "corners"],
  computed: {
    rows() {
      return prices[this.category][this.corners];
    },
    items() {
      return this.rows
        .entries()
        .map(([product, prices]) => ({ product, ...prices }));
    }
  },
  mounted() {
    viewedPricing("pricing-page");
  },
  methods: {
    price(row, qty) {
      let p = row.prices[qty];
      return p ? "$" + p.toFixed(2) : "N/A";
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/pages/homepage/pricing/PricingTable.vue